module.exports = __webpack_public_path__ + "img/C08TechElephantArcherChampion_ua.a94e072e.webp";